import {
  DocumentAnyData,
  PreviousDocument,
  SupportingDocument, TransportDocument,
} from 'features/declaration/models/schemas/documentSchemas'
import {
  ConsignmentItemFormValues,
  ConsignmentItemData,
} from 'features/declaration/consignment-item/models/schema'
import { excludeDeleted } from 'shared/lib/common-util'
import createDocumentSaver, { DocumentSaveResult } from '../../document/components/createDocumentSaver'
import { toDocumentSaveBatch } from '../../document/models/formValuesToModel'
import resequenceDocuments from '../../document/models/resequence'
import { createConsignmentItemDocuments } from '../api/createConsignmentItemDocuments'
import { updateConsignmentItemDocuments } from '../api/updateConsignmentItemDocuments'

function getDocumentFromForm(formValues: ConsignmentItemData): DocumentAnyData[] {
  const existingTransportDocuments: TransportDocument[] = resequenceDocuments(formValues.transportDocument.filter(excludeDeleted))
  const existingPreviousDocuments: PreviousDocument[] = resequenceDocuments(formValues.previousDocument.filter(excludeDeleted))
  const existingSupportingDocuments: SupportingDocument[] = resequenceDocuments(formValues.supportingDocument.filter(excludeDeleted))

  return [
    ...existingTransportDocuments,
    ...existingPreviousDocuments,
    ...existingSupportingDocuments,
  ] as DocumentAnyData[]
}

export default function useSaveConsignmentItemDocuments(transitOperationId: number) {
  const saveConsignmentItemDocuments = async (
    consignmentItemId: number,
    formValues: ConsignmentItemFormValues,
  ): Promise<DocumentSaveResult> => {
    const saveDocuments = createDocumentSaver({
      createDocumentsFn: (documents) => createConsignmentItemDocuments(transitOperationId, consignmentItemId, documents),
      updateDocumentsFn: (documents) => updateConsignmentItemDocuments(transitOperationId, consignmentItemId, documents),
    })

    const documents = toDocumentSaveBatch(getDocumentFromForm(formValues))

    return saveDocuments(documents)
  }

  return { saveConsignmentItemDocuments }
}
